
export const DATAWIN_SET_DATA_MODEL_ITEM = 'data/datawin/SET_DATA_MODEL_ITEM';
export const DATAWIN_SET_FETCH_ATTRIBUTE_VISIBILITY = 'data/datawin/DATAWIN_SET_FETCH_ATTRIBUTE_VISIBILITY';
export const DATAWIN_SET_FETCH_ATTRIBUTES = 'data/datawin/DATAWIN_SET_FETCH_ATTRIBUTES';
export const DATAWIN_SET_FETCH_GEOM = 'data/datawin/DATAWIN_SET_FETCH_GEOM';
export const DATAWIN_SET_FETCH_PANEL_VISIBILITY = 'data/datawin/DATAWIN_SET_FETCH_PANEL_VISIBILITY';
export const DATAWIN_SET_OBJECT = 'data/datawin/SET_OBJECT';
export const DATAWIN_SET_OBJECT_LIST = 'data/datawin/SET_OBJECT_LIST';
export const DATAWIN_UPDATE_ATTRIBUTE_IN_OBJECT_LIST = 'data/datawin/DATAWIN_UPDATE_ATTRIBUTE_IN_OBJECT_LIST';

export default function getActions(dispatch) {
    return {
        setDatawinDataModelItemId: (id) => dispatch({
            type: DATAWIN_SET_DATA_MODEL_ITEM,
            id
        }),
        setDatawinFetchAttributes: (id, attributes) => dispatch({
            type: DATAWIN_SET_FETCH_ATTRIBUTES,
            id, attributes
        }),
        setDatawinFetchAttributeVisibility: (id, attributes) => dispatch({
            type: DATAWIN_SET_FETCH_ATTRIBUTE_VISIBILITY,
            id, attributes
        }),
        setDatawinFetchGeom: (id, geom) => dispatch({
            type: DATAWIN_SET_FETCH_GEOM,
            id, geom
        }),
        setDatawinFetchPanelVisibility: (visible) => dispatch({
            type: DATAWIN_SET_FETCH_PANEL_VISIBILITY,
            visible
        }),
        setDatawinObject: (object) => dispatch({
            type: DATAWIN_SET_OBJECT,
            object
        }),
        setDatawinObjectList: (id, objectList, mode) => dispatch({
            type: DATAWIN_SET_OBJECT_LIST,
            id, objectList, mode
        }),
        updateAttributeInObjectList: (id, gids, attribute, value) => dispatch({
            type: DATAWIN_UPDATE_ATTRIBUTE_IN_OBJECT_LIST,
            id, gids, attribute, value
        })
    };
}
